<template>
  <div>
    <!-- <v-toolbar flat color="white">
            <v-toolbar-title>My CRUD</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
                </template>
                <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                        <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                        <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                        <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                        <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                        <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar> -->
    <v-container v-if="!loading">
      <v-card-title>
        Arquivos
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="saveSelectedItems"
          :disabled="loadingDocument"
          :loading="loadingDocument"
          >Gerar Ata</v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="files"
        disable-initial-sort
        class="elevation-1"
        :search="search"
        :pagination.sync="pag"
      >
        <template v-slot:items="props">
          <td>
            <v-checkbox
              hide-details
              color="primary"
              @change="(value) => handleCheckboxChange(props.item, value)"
            ></v-checkbox>
          </td>

          <td>{{ props.item.created_at | formatarDate }}</td>
          <td>{{ props.item.installation_number }}</td>
          <td>{{ props.item.power_plant_id }}</td>
          <td>{{ props.item.expected_competence }}</td>
          <td>{{ props.item.last_export_at | formatarDate }}</td>
          <td>{{ props.item.status }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="openFileItems(props.item)">
              view_headline
            </v-icon>
            <!-- <v-icon
                        small
                        class="mr-2"
                        @click="editItem(props.item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteItem(props.item)"
                    >
                        delete
                    </v-icon> -->
          </td>
        </template>
        <!-- <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template> -->
      </v-data-table>

      <v-dialog v-model="utilityMinuteGenerated" max-width="300px" persistent>
        <v-card>
          <v-card-title class="bold lighten-2" primary-title>
            <span style="font-size: 18px">Acesse a ata gerada</span>
          </v-card-title>

          <v-card-actions>
            <v-btn
              color="green"
              class="v-btn--medium"
              :href="utilityMinuteUrl"
              target="_blank"
            >
              Acessar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              class="v-btn--medium"
              @click="utilityMinuteGenerated = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <utility-file-items />
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import UtilityFileItems from "../../components/utility/UtilityFileItems.vue";
import { eventBus } from "../../main";
import { saveUtilityMinutes } from "../../services/utilityMinutes";

export default {
  data: () => ({
    dialog: false,
    headers: [
      { text: "Marcar", value: "checkbox" },
      {
        text: "Criado em",
        align: "left",
        value: "created_at",
      },
      { text: "Unidade Geradora", value: "installation_number" },
      { text: "Planta", value: "power_plant_id" },
      { text: "Competencia Esperada", value: "expected_competence" },
      { text: "Última Exportação", value: "last_export_at" },
      { text: "Status", value: "status" },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    search: "",
    pag: {
      rowsPerPage: 20,
      // totalItems: 20
    },
    listItemsChecked: [],
    loadingDocument: false,
    color: "",
    snackMessage: "",
    snackbar: false,
    utilityMinuteUrl: "",
    utilityMinuteGenerated: false,
  }),
  components: {
    UtilityFileItems,
  },
  computed: {
    ...mapState("utility", ["files", "loading"]),
    ...mapState(["config", "user"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions("utility", ["getUtilityFiles"]),
    initialize() {
      this.getUtilityFiles();
    },
    openFileItems(item) {
      eventBus.$emit("utilityItemsDialog", item);
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    handleCheckboxChange(item, value) {
      if (value) {
        this.listItemsChecked.push(item.id);
      } else {
        const index = this.listItemsChecked.indexOf(item.id);
        this.listItemsChecked.splice(index, 1);
      }
    },

    async saveSelectedItems() {
      const items = this.listItemsChecked;
      const user = this.user.email;
      this.loadingDocument = true;
      try {
        this.snack(
          "O sistema está gerando a ata. Isso pode levar até 2 minutos.",
          "green",
        );
        const responseUrl = await saveUtilityMinutes(items, user);
        this.utilityMinuteUrl = responseUrl;
        this.utilityMinuteGenerated = true;
        this.snack("Documento gerado com sucesso!", "green");
      } catch (error) {
        this.snack("Erro ao salvar itens: " + error.message, "red");
      } finally {
        this.loadingDocument = false;
        this.snackbar = true;
      }
    },

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>
